import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import Share from "react-native-share";
import { actions } from "@reducers/shareReducer";
import { Modal } from "@components/TrackedModal";
import colors from "@constants/color";
import Toast from "react-native-simple-toast";
import CloseIcon from "@assets/svg/CloseIcon";
import Text from "@components/AppText";
import WhatsappWhite from "@assets/svg/WhatsappWhite";
import t from "@constants/localization";
import CustomProgressBar from "./ProgressBar";

const PATH = "components/ShareDialog";

const ShareDialog = React.memo((props) => {
  const {
    urls,
    showShareModal,
    progressBar,
    isImagesShared,
    message,
    isDescriptionShared,
  } = useSelector((state) => state.share);

  const dispatch = useDispatch();

  const share = (optionsObj) => {
    const options = {
      failOnCancel: false,
      social: Share.Social.WHATSAPP,
      title: "Share via",
      ...optionsObj,
    };

    return Share.shareSingle(options);
  };

  const handleSharePdf = () => {
    if (urls.length) {
      const options = {
        urls,
      };

      Toast.showWithGravity(t(`${PATH}/sharingPDF`), Toast.LONG, Toast.BOTTOM);

      share(options).then((data) => {
        if (data.message) {
          dispatch(actions.changeImageSharedStatus());
        }
      });
    }
  };

  const handleShareLink = () => {
    const options = {
      message,
    };

    Toast.showWithGravity(
      t(`${PATH}/sharingDescription`),
      Toast.LONG,
      Toast.BOTTOM,
    );

    share(options).then((data) => {
      if (data.message) {
        dispatch(actions.changeDescriptionStatus());
      }
    });
  };

  useEffect(() => {
    if (isDescriptionShared && isImagesShared) {
      dispatch(actions.returnToInitState());
    }
  }, [isImagesShared, isDescriptionShared, dispatch]);

  const dispatchInitState = () => {
    dispatch(actions.returnToInitState());
  };

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      animationType="fade"
      visible={showShareModal}
      transparent={true}
      eventType="Share PDF / Description Modal"
      onRequestClose={dispatchInitState}
    >
      <TouchableOpacity
        testID="sd-close-button"
        onPress={dispatchInitState}
        style={{
          position: "absolute",
          right: 15,
          padding: 20,
          zIndex: 10,
          top: 20,
        }}
      >
        <CloseIcon fill="#fff" />
      </TouchableOpacity>
      <View style={styles.modalContentWrapper}>
        <View style={styles.dialog}>
          <TouchableOpacity
            testID="sd-share-pdf-button"
            onPress={handleSharePdf}
            style={styles.infoWrapper}
          >
            <View style={styles.wabuttonContainer}>
              <WhatsappWhite />
              <Text
                fontType="content1"
                style={{
                  fontWeight: "bold",
                  color: colors.white,
                  marginLeft: 10,
                }}
              >
                {t(`${PATH}/shareItemList`)}
              </Text>
            </View>
          </TouchableOpacity>
          <TouchableOpacity
            testID="sd-share-description-button"
            onPress={handleShareLink}
            style={styles.infoWrapper}
          >
            <View style={styles.wabuttonContainer}>
              <WhatsappWhite />
              <Text
                fontType="content1"
                style={{
                  fontWeight: "bold",
                  color: colors.white,
                  marginLeft: 10,
                }}
              >
                {t(`${PATH}/shareStoreLink`)}
              </Text>
            </View>
          </TouchableOpacity>
          {progressBar && <CustomProgressBar />}
        </View>
      </View>
    </Modal>
  );
});

const styles = StyleSheet.create({
  dialog: {
    padding: 16,
    backgroundColor: "#fff",
    borderRadius: 5,
    elevation: 6,
    width: "85%",
    justifyContent: "center",
    alignItems: "center",
  },
  infoWrapper: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
  },
  checkBox: {
    height: 20,
    width: 20,
    borderRadius: 3,
    marginRight: 5,
    borderWidth: 3,
    borderColor: colors.primary,
  },
  modalContentWrapper: {
    backgroundColor: "rgba(0, 0, 0, .8)",
    padding: 32,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  wabuttonContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.lima,
    paddingHorizontal: 20,
    paddingVertical: 10,
    height: 40,
    borderRadius: 20,
  },
});

export default ShareDialog;
